<bp-error-shell class="reddish">
	<div class="ng-content-title">Access Forbidden</div>

	<div class="ng-content-error-image display-contents">
		<mat-icon class="material-icons-round"> do_not_disturb_on </mat-icon>
	</div>
</bp-error-shell>
